import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { useSession } from '../auth/session'
import { EmptyState } from './EmptyState'

/**
 * A page the user may not use says so, instead of rendering a form whose every
 * action the server will refuse.
 *
 * Reached by a pasted link or a bookmark from someone with more access. The server
 * is still the control — this only spares the user filling in a form to be told
 * no at the end.
 */
export function RequirePermission({ all = [], any, children }: { all?: string[]; any?: string[]; children: ReactNode }) {
  const can = useSession((s) => s.can)

  if (all.every((permission) => can(permission)) && (!any || any.some((permission) => can(permission)))) {
    return <>{children}</>
  }

  return (
    <div className="rounded-lg border border-dpl-border bg-dpl-surface shadow-sm">
      <EmptyState
        title="This page is not available to you"
        hint="Your role does not include it. If you need it, ask the system administrator to change your role."
      />
      <p className="pb-6 text-center text-sm">
        <Link to="/" className="text-dpl-primary underline">
          Back to the dashboard
        </Link>
      </p>
    </div>
  )
}
